import { AxiosInstance } from "axios";
import { IBaseUserDto } from "../interface/user/IBaseUserDto";
import { ISignInDto } from '../interface/ISignInDto';

enum UserAuthServiceEnum {
  getUser = "user",
  signInWithMFA = "user/sign-in?mfaCode=",
  signIn = "user/sign-in",
  signOut = "user/sign-out",
  sendMFACode = "user/send-mfa"
}

export class UserAuthService {
  protected restClient: AxiosInstance;
  constructor(restClient: AxiosInstance) {
    this.restClient = restClient;
  }
  public getUser = async (): Promise<IBaseUserDto> => await this.GET(UserAuthServiceEnum.getUser);
  public signIn = async (recaptcha: string): Promise<ISignInDto> => await this.GET(UserAuthServiceEnum.signIn, recaptcha);
  public signInWithMFA = async (recaptcha: string, mfaCode?: string): Promise<ISignInDto> => await this.GET(UserAuthServiceEnum.signInWithMFA + mfaCode, recaptcha, "text");
  public signOut = async (): Promise<void> => await this.GET(UserAuthServiceEnum.signOut);
  public sendMFACode = async (): Promise<void> => await this.GET(UserAuthServiceEnum.sendMFACode);

  private async GET(url, captchaToken = null, responseType = null) {
    try {
      const response = (
        await this.restClient.get(url, {
          responseType: responseType ? responseType : "json",
          headers: {
            "captcha": captchaToken
          }
        })
      ).data;
      return response;
    } catch (error) {
      throw error;
    }
  }
}
